/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import { useSelector } from 'react-redux'
import Dialog from '../../../common/Dialog'
import { planTypes } from '../../../../consts'
import $t from '../../../../i18n'

import './AppointmentConfirmationDialog.css'

const AppointmentConfirmationDialog = props => {
  const {
    title,
    handleOk,
    closePopup,
    isVisible,
    shouldContactSupport,
    supportMessage = $t('dialogs.AppointmentConfirmationDialog.supportMessage'),
    isCancelRequest = false,
    isPendingAppointment = false,
    confirmText,
  } = props

  const planType = useSelector(state => state.payment.selectedPlan?.type)
  const mySubs = useSelector(state => state.payment.my_subscriptions)

  const [alertData, setAlertData] = useState({})

  const onApprove = e => {
    let alertTitle = confirmText
    if (
      (planType === planTypes.ONE_TIME || mySubs?.length === 0) &&
      isCancelRequest &&
      !isPendingAppointment
    ) {
      alertTitle = $t('dialogs.cancelAppointment.oneTimePopupCancelSubtitle')
    }
    if (!!alertTitle) {
      setAlertData({
        title: alertTitle,
        body: '',
        onCancel: handleOk,
        actions: [
          <Button
            key="1"
            className="dialog-action"
            type="primary"
            onClick={handleOk}
          >
            {$t('dialogs.cancelAppointment.oneTimePopupContinue')}
          </Button>,
        ],
      })
    } else {
      handleOk(e)
    }
  }

  const dialogActions = [
    <Button
      key="1"
      className="dialog-action"
      type="primary"
      onClick={closePopup}
    >
      {$t('dialogs.AppointmentConfirmationDialog.no')}
    </Button>,
    <Button
      key="2"
      className="dialog-action"
      type="secondary"
      onClick={onApprove}
    >
      {$t('dialogs.AppointmentConfirmationDialog.yes')}
    </Button>,
  ]

  useEffect(() => {
    if (isVisible) {
      if (shouldContactSupport) {
        setAlertData({
          title: supportMessage,
          body: '',
          onCancel: closePopup,
          actions: [
            <Button
              key="1"
              className="dialog-action"
              type="primary"
              onClick={closePopup}
            >
              {$t('common.gotIt')}
            </Button>,
          ],
        })
      } else {
        setAlertData({
          title,
          body: '',
          actions: dialogActions,
          onCancel: closePopup,
        })
      }
    }
  }, [isVisible])

  const renderUi = () => {
    return (
      <Dialog
        className="cancel-appointment-dialog-container"
        title={alertData?.title}
        open={isVisible}
        footerActions={alertData?.actions}
        onCancel={alertData?.onCancel}
      >
        {alertData?.body}
      </Dialog>
    )
  }

  return renderUi()
}

export default AppointmentConfirmationDialog
